<div class="main-page">

  <div class="container">

    <div class="setting-text-area">

      <div
        class="innerPage setting-text-area-inner"
        style="padding: 20px; border-radius: 20px;"
      >

        <!-- Header -->
        <div class="leads-header">

          <div>

            <div class="leads-title">

              <span
                class="leads-title-icon"
                aria-hidden="true"
              >
                <i class="fa-solid fa-user-group"></i>
              </span>

              Leads

            </div>

            <div class="leads-subtitle">
              Manage leads received from AI searches
            </div>

          </div>


          <div class="leads-badge">

            {{ leads.length }} Leads

          </div>

        </div>


        <!-- Loading -->
        <div
          class="leads-loading"
          *ngIf="loading"
        >

          <i class="fa-solid fa-spinner fa-spin"></i>

          Loading leads...

        </div>


        <!-- Empty State -->
        <div
          class="leads-empty"
          *ngIf="!loading && !leads.length"
        >

          <div class="leads-empty__icon">

            <i class="fa-solid fa-user-group"></i>

          </div>

          <div class="leads-empty__title">

            No leads yet

          </div>

          <div class="leads-empty__subtitle">

            When users select your business from an AI search,
            their leads will appear here.

          </div>

        </div>


        <!-- Leads Table -->
        <div
          class="leads-table-wrap"
          *ngIf="!loading && leads.length"
        >

          <table class="table leads-table">

            <thead>

              <tr>

                <th scope="col">
                  User
                </th>

                <th scope="col">
                  AI Request
                </th>

                <th scope="col">
                  Email
                </th>

                <th scope="col">
                  Date
                </th>

                <th scope="col">
                  Status
                </th>

                <th
                  scope="col"
                  class="leads-actions-col"
                >
                  Action
                </th>

              </tr>

            </thead>


            <tbody>

              <tr *ngFor="let lead of leads">


                <!-- USER -->
                <td class="lead-user">

                  <div class="lead-user-avatar">

                    {{
                      (
                        lead.userId?.firstName ||
                        lead.userId?.userName ||
                        'U'
                      ).trim().charAt(0).toUpperCase()
                    }}

                  </div>


                  <div>

                    <div class="lead-user-name">

                      {{
                        lead.userId?.name ||
                        lead.userId?.userName ||
                        (
                          (lead.userId?.firstName || '') +
                          ' ' +
                          (lead.userId?.lastName || '')
                        ).trim() ||
                        'Unknown User'
                      }}

                    </div>

                  </div>

                </td>


                <!-- AI REQUEST -->
                <td class="lead-request">

                  <div class="ai-label">

                    <i class="fa-solid fa-wand-magic-sparkles"></i>

                    AI Request

                  </div>

                  <div class="lead-prompt">

                    {{ lead.prompt || '-' }}

                  </div>

                </td>


                <!-- CONTACT -->
                <td class="lead-contact">

                  <!-- Email -->
                  <div
                    *ngIf="lead.userId?.email"
                  >

                    <i class="fa-regular fa-envelope"></i>

                    {{ lead.userId.email }}

                  </div>


                  <!-- Phone -->
                  <div
                    *ngIf="lead.userId?.contactNo"
                  >

                    <i class="fa-solid fa-phone"></i>

                    {{ lead.userId.contactNo }}

                  </div>


                  <!-- No Contact -->
                  <div
                    *ngIf="
                      !lead.userId?.email &&
                      !lead.userId?.contactNo
                    "
                  >
                    -
                  </div>

                </td>


                <!-- DATE -->
                <td class="lead-date">

                  <i class="fa-regular fa-calendar"></i>

                  {{ lead.createdAt | date:"MMM dd, yyyy" }}

                </td>


                <!-- STATUS -->
                <td>

                  <span
                    class="lead-status"
                    [ngClass]="getStatusClass(lead.status)"
                  >

                    {{ lead.status | titlecase }}

                  </span>

                </td>


                <!-- ACTION -->
               <td class="lead-actions">

  <!-- Mark as Contacted -->
  <button
    *ngIf="lead.status === 'new'"
    type="button"
    class="lead-action-btn contacted-btn"
    title="Mark as Contacted"
    (click)="markAsContacted(lead)">

    <i class="fa-solid fa-check"></i>

  </button>


  <!-- Archive -->
  <button
    *ngIf="lead.status !== 'archived'"
    type="button"
    class="lead-action-btn archive-btn"
    title="Archive Lead"
    (click)="archiveLead(lead)">

    <i class="fa-solid fa-box-archive"></i>

  </button>


  <!-- Delete -->
  <button
    type="button"
    class="lead-action-btn delete-btn"
    title="Delete Lead"
    (click)="deleteLead(lead)">

    <i class="fa-solid fa-trash"></i>

  </button>

</td>


              </tr>

            </tbody>

          </table>

        </div>


      </div>

    </div>

  </div>

</div>